import { DTOInterestTutorialResponse } from './DTOInterestTutorial';

export const SIGN_UP_POST_FLOW_STEP_TYPES = {
  INTEREST_SELECTION: 'INTEREST_SELECTION',
} as const;
export type SignUpPostFlowStepType =
  (typeof SIGN_UP_POST_FLOW_STEP_TYPES)[keyof typeof SIGN_UP_POST_FLOW_STEP_TYPES];

export interface DTOSignUpPostFlowResponse {
  result: {
    /** 회원가입 후 수행해야 하는 스텝 목록 */
    steps: SignUpPostFlowStepType[];

    /** 관심사 선택 데이터 (steps에 INTEREST_SELECTION 포함 시) */
    interestSelection?: DTOInterestTutorialResponse;
  };
}
